module.exports = __webpack_public_path__ + "4b17dff442933dd9c7abd4facf431eb5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/Tu_Van_Phap_Ly_San_Pham.svg
// module id = ./assets/images/advisory/Tu_Van_Phap_Ly_San_Pham.svg
// module chunks = 0